export default "__VITE_ASSET__DFGA8aSP__"